import React, { useState } from "react";
import { Box, Typography, Card } from "@mui/material";
import ComboDaysModal from "./ComboDaysModal";

const GreenFireComponent = ({ currentDays, prizes }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);

  const getProgressWidth = () => {
    const maxDays = Math.max(...prizes.map((prize) => prize.days));
    return `${(currentDays / maxDays) * 100}%`;
  };

  return (
    <>
      <Card
        sx={{
          p: 3,
          boxShadow: "none",
          borderRadius: "10px",
          color: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setOpen(true)}
      >
        <img
          src="/img/supervisor/fire.svg"
          alt="Fire Icon"
          width="24"
          height="24"
        />
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              ml: 3,
            }}
          >
            Нагороди за комбо
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              color: "#22FF8A",
              ml: 3,
            }}
          >
            + Додати
          </Typography>
        </Box>
      </Card>
      <ComboDaysModal
        open={open}
        onClose={() => setOpen(false)}
        active={active}
        setActive={setActive}
        prizes={prizes}
        currentDays={currentDays}
        getProgressWidth={getProgressWidth}
      />
    </>
  );
};

export default GreenFireComponent;
